import script from "./BookingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingForm.vue?vue&type=script&setup=true&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=3d449e2e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\MXRover\\mxrover_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d449e2e"]])

export default __exports__